import blue from "@material-ui/core/colors/blue";
import green from "@material-ui/core/colors/green";
import grey from "@material-ui/core/colors/grey";

const LIST_ITEM_MAX_HEIGHT = 30;
const STANDARD_BTN_MENU_MIN_WIDTH = 150;

// this will be changed when wireframes are finalized
export const theme = {
  typography: {
    useNextVariants: true,
    fontFamily: [
      "OpenSans",
      "Arial",
      "Helvetica",
      "Times New Roman",
      "sans-serif",
    ].join(","),
    subtitle2: {
      fontSize: 11,
      color: grey[600],
    },
    // smallBold: {
    //   fontSize: 11,
    //   color: blue[900],
    //   textTransform: "uppercase"
    // }
  },
  palette: {
    primary: blue,
    secondary: green,
    background: {
      default: "#fff",
    },
  },
  overrides: {
    MuiDialog: {
      paper: {
        minWidth: "25%",
      },
    },
    MuiMenuItem: {
      root: {
        minWidth: STANDARD_BTN_MENU_MIN_WIDTH,
      },
    },
    MuiListItem: {
      dense: {
        maxHeight: LIST_ITEM_MAX_HEIGHT,
      },
    },
    MuiButton: {
      sizeSmall: {
        maxHeight: LIST_ITEM_MAX_HEIGHT,
      },
      containedSecondary: {
        backgroundColor: green["500"],
        color: grey[50],
      },
      label: {
        fontWeight: "bolder",
      },
    },
    MuiOutlinedInput: {
      adornedEnd: {
        paddingRight: 0,
      },
    },
    MuiButtonGroup: {
      // sizeSmall: {
      //   maxHeight: LIST_ITEM_MAX_HEIGHT,
      // },
      groupedContainedPrimary: {
        "&:not(:last-child)": {
          borderRight: `1px solid #fff`,
        },
      },
      groupedContainedSecondary: {
        "&:not(:last-child)": {
          borderRight: `1px solid #fff`,
        },
      },
    },
    MuiExpansionPanelSummary: {
      content: {
        margin: 0,
        "&$expanded": {
          margin: 0,
        },
      },
    },
  },
  espn: {
    default: {
      sizes: {
        btnWidthStandard: STANDARD_BTN_MENU_MIN_WIDTH,
        footerHeight: 30,
        headerHeight: "3.152rem",
      },
      colors: {},
      fontFamily: {
        content: [
          "OpenSans",
          "Arial",
          "Helvetica",
          "Times New Roman",
          "sans-serif",
        ].join(","),
        title: [
          "OpenSans",
          "Arial",
          "Helvetica",
          "Times New Roman",
          "sans-serif",
        ].join(","),
        boldFont: [
          "OpenSans-SemiBold",
          "Open Sans",
          "OpenSansBold",
          "OpenSans",
        ].join(","),
      },
    },
  },
};
